import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
  Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Title = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  font-weight: 500;
  color: #192c47;
  margin: 15px 0;
`;

const Text = styled(TextLayoutComponent)`
  font-size: 16px;
  color: #192c47;
  font-weight: 400;
  margin: 10px 0;
`;

const Button = styled(ButtonLayoutComponent)`
  &&& {
    margin-top: ${({ disabled }) => (disabled ? '10px' : '30px')};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 650px;
  @media (max-width: 580px) {
    width: 80%;
  }
  min-height: 275px;
  border: 2px solid #eaeaea;
  border-radius: 4px;
  padding: 45px 25px;
  background-color: #fff;
`;

const Loader = styled(LoaderLayoutComponent)``;

const ErrorMessage = styled(TextLayoutComponent.Error)``;

export {
  Button,
  Container,
  ErrorMessage,
  Loader,
  MessageContainer,
  Text,
  Title,
};
